/**
 * Fixes literal HTML character references (e.g. &#39; &eacute;) that ended up as text
 * because of escaping or CMS pipelines. Scoped to displayed text nodes only (no scripts/styles).
 */
(function () {
  const ENTITY_REGEX = /&(#(?:x[0-9a-fA-F]{1,8}|[0-9]{1,10})|[a-zA-Z][a-zA-Z0-9]*);/g;

  /** Common named entities; extend as needed for storefront copy */
  const NAMED = new Map([
    ['quot', '"'],
    ['apos', "'"],
    ['nbsp', '\u00a0'],
    ['iexcl', '\u00a1'],
    ['cent', '\u00a2'],
    ['pound', '\u00a3'],
    ['curren', '\u00a4'],
    ['yen', '\u00a5'],
    ['brvbar', '\u00a6'],
    ['sect', '\u00a7'],
    ['uml', '\u00a8'],
    ['copy', '\u00a9'],
    ['ordf', '\u00aa'],
    ['laquo', '\u00ab'],
    ['not', '\u00ac'],
    ['shy', '\u00ad'],
    ['reg', '\u00ae'],
    ['macr', '\u00af'],
    ['deg', '\u00b0'],
    ['plusmn', '\u00b1'],
    ['sup2', '\u00b2'],
    ['sup3', '\u00b3'],
    ['acute', '\u00b4'],
    ['micro', '\u00b5'],
    ['para', '\u00b6'],
    ['middot', '\u00b7'],
    ['cedil', '\u00b8'],
    ['sup1', '\u00b9'],
    ['ordm', '\u00ba'],
    ['raquo', '\u00bb'],
    ['frac14', '\u00bc'],
    ['frac12', '\u00bd'],
    ['frac34', '\u00be'],
    ['iquest', '\u00bf'],
    ['Agrave', '\u00c0'],
    ['Aacute', '\u00c1'],
    ['Acirc', '\u00c2'],
    ['Atilde', '\u00c3'],
    ['Auml', '\u00c4'],
    ['Aring', '\u00c5'],
    ['AElig', '\u00c6'],
    ['Ccedil', '\u00c7'],
    ['Egrave', '\u00c8'],
    ['Eacute', '\u00c9'],
    ['Ecirc', '\u00ca'],
    ['Euml', '\u00cb'],
    ['Igrave', '\u00cc'],
    ['Iacute', '\u00cd'],
    ['Icirc', '\u00ce'],
    ['Iuml', '\u00cf'],
    ['ETH', '\u00d0'],
    ['Ntilde', '\u00d1'],
    ['Ograve', '\u00d2'],
    ['Oacute', '\u00d3'],
    ['Ocirc', '\u00d4'],
    ['Otilde', '\u00d5'],
    ['Ouml', '\u00d6'],
    ['times', '\u00d7'],
    ['Oslash', '\u00d8'],
    ['Ugrave', '\u00d9'],
    ['Uacute', '\u00da'],
    ['Ucirc', '\u00db'],
    ['Uuml', '\u00dc'],
    ['Yacute', '\u00dd'],
    ['THORN', '\u00de'],
    ['szlig', '\u00df'],
    ['agrave', '\u00e0'],
    ['aacute', '\u00e1'],
    ['acirc', '\u00e2'],
    ['atilde', '\u00e3'],
    ['auml', '\u00e4'],
    ['aring', '\u00e5'],
    ['aelig', '\u00e6'],
    ['ccedil', '\u00e7'],
    ['egrave', '\u00e8'],
    ['eacute', '\u00e9'],
    ['ecirc', '\u00ea'],
    ['euml', '\u00eb'],
    ['igrave', '\u00ec'],
    ['iacute', '\u00ed'],
    ['icirc', '\u00ee'],
    ['iuml', '\u00ef'],
    ['eth', '\u00f0'],
    ['ntilde', '\u00f1'],
    ['ograve', '\u00f2'],
    ['oacute', '\u00f3'],
    ['ocirc', '\u00f4'],
    ['otilde', '\u00f5'],
    ['ouml', '\u00f6'],
    ['divide', '\u00f7'],
    ['oslash', '\u00f8'],
    ['ugrave', '\u00f9'],
    ['uacute', '\u00fa'],
    ['ucirc', '\u00fb'],
    ['uuml', '\u00fc'],
    ['yacute', '\u00fd'],
    ['thorn', '\u00fe'],
    ['yuml', '\u00ff'],
    ['OElig', '\u0152'],
    ['oelig', '\u0153'],
    ['Scaron', '\u0160'],
    ['scaron', '\u0161'],
    ['Yuml', '\u0178'],
    ['fnof', '\u0192'],
    ['circ', '\u02c6'],
    ['tilde', '\u02dc'],
    ['Alpha', '\u0391'],
    ['Beta', '\u0392'],
    ['Gamma', '\u0393'],
    ['Delta', '\u0394'],
    ['Epsilon', '\u0395'],
    ['Zeta', '\u0396'],
    ['Eta', '\u0397'],
    ['Theta', '\u0398'],
    ['Iota', '\u0399'],
    ['Kappa', '\u039a'],
    ['Lambda', '\u039b'],
    ['Mu', '\u039c'],
    ['Nu', '\u039d'],
    ['Xi', '\u039e'],
    ['Omicron', '\u039f'],
    ['Pi', '\u03a0'],
    ['Rho', '\u03a1'],
    ['Sigma', '\u03a3'],
    ['Tau', '\u03a4'],
    ['Upsilon', '\u03a5'],
    ['Phi', '\u03a6'],
    ['Chi', '\u03a7'],
    ['Psi', '\u03a8'],
    ['Omega', '\u03a9'],
    ['alpha', '\u03b1'],
    ['beta', '\u03b2'],
    ['gamma', '\u03b3'],
    ['delta', '\u03b4'],
    ['epsilon', '\u03b5'],
    ['zeta', '\u03b6'],
    ['eta', '\u03b7'],
    ['theta', '\u03b8'],
    ['iota', '\u03b9'],
    ['kappa', '\u03ba'],
    ['lambda', '\u03bb'],
    ['mu', '\u03bc'],
    ['nu', '\u03bd'],
    ['xi', '\u03be'],
    ['omicron', '\u03bf'],
    ['pi', '\u03c0'],
    ['rho', '\u03c1'],
    ['sigmaf', '\u03c2'],
    ['sigma', '\u03c3'],
    ['tau', '\u03c4'],
    ['upsilon', '\u03c5'],
    ['phi', '\u03c6'],
    ['chi', '\u03c7'],
    ['psi', '\u03c8'],
    ['omega', '\u03c9'],
    ['thetasym', '\u03d1'],
    ['upsih', '\u03d2'],
    ['piv', '\u03d6'],
    ['ensp', '\u2002'],
    ['emsp', '\u2003'],
    ['thinsp', '\u2009'],
    ['zwnj', '\u200c'],
    ['zwj', '\u200d'],
    ['lrm', '\u200e'],
    ['rlm', '\u200f'],
    ['ndash', '\u2013'],
    ['mdash', '\u2014'],
    ['lsquo', '\u2018'],
    ['rsquo', '\u2019'],
    ['sbquo', '\u201a'],
    ['ldquo', '\u201c'],
    ['rdquo', '\u201d'],
    ['bdquo', '\u201e'],
    ['dagger', '\u2020'],
    ['Dagger', '\u2021'],
    ['bull', '\u2022'],
    ['hellip', '\u2026'],
    ['permil', '\u2030'],
    ['prime', '\u2032'],
    ['Prime', '\u2033'],
    ['lsaquo', '\u2039'],
    ['rsaquo', '\u203a'],
    ['oline', '\u203e'],
    ['frasl', '\u2044'],
    ['euro', '\u20ac'],
    ['trade', '\u2122'],
    ['larr', '\u2190'],
    ['uarr', '\u2191'],
    ['rarr', '\u2192'],
    ['darr', '\u2193'],
    ['harr', '\u2194'],
    ['crarr', '\u21b5'],
    ['lceil', '\u2308'],
    ['rceil', '\u2309'],
    ['lfloor', '\u230a'],
    ['rfloor', '\u230b'],
    ['loz', '\u25ca'],
    ['spades', '\u2660'],
    ['clubs', '\u2663'],
    ['hearts', '\u2665'],
    ['diams', '\u2666'],
    ['amp', '&'],
    ['lt', '<'],
    ['gt', '>'],
  ]);

  function decodeNumeric(code) {
    const n =
      code[1] === 'x' || code[1] === 'X'
        ? parseInt(code.slice(2), 16)
        : parseInt(code.slice(1), 10);
    if (Number.isNaN(n)) return null;
    if (n === 0) return '\ufffd';
    try {
      if (n <= 0xffff) return String.fromCharCode(n);
      return String.fromCodePoint(n);
    } catch {
      return null;
    }
  }

  /** One pass over standard semicolon-terminated references */
  function decodeOnePass(text) {
    return text.replace(ENTITY_REGEX, (full, ref) => {
      if (!ref.length) return full;
      if (ref[0] === '#') {
        const ch = decodeNumeric(ref);
        return ch !== null ? ch : full;
      }
      const named = NAMED.get(ref.toLowerCase());
      return named !== undefined ? named : full;
    });
  }

  /** Resolves chained encodings (&amp;#39;) up to maxPass times */
  function decodeAll(text, maxPass) {
    if (typeof text !== 'string' || !text.includes('&')) return text;
    const cap = typeof maxPass === 'number' ? maxPass : 8;
    let cur = text;
    for (let i = 0; i < cap; i++) {
      const next = decodeOnePass(cur);
      if (next === cur) break;
      cur = next;
    }
    return cur;
  }

  const SKIP_TAGS = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEMPLATE',
    'PRE',
    'CODE',
    'KBD',
    'SAMP',
    'TEXTAREA',
  ]);

  function shouldRejectTextNode(node) {
    if (!node.parentElement) return true;
    let el = node.parentElement;
    while (el) {
      if (SKIP_TAGS.has(el.tagName)) return true;
      if (el.classList && el.classList.contains('lw-skip-entity-decode')) return true;
      el = el.parentElement;
    }
    return false;
  }

  function decodeSubtree(root) {
    if (!root || !root.nodeType) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (!shouldRejectTextNode(root) && root.nodeValue && root.nodeValue.includes('&')) {
        const d = decodeAll(root.nodeValue);
        if (d !== root.nodeValue) root.nodeValue = d;
      }
      return;
    }

    try {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      const batch = [];
      let n = walker.nextNode();
      while (n) {
        const textNode = /** @type {Text} */ (n);
        if (
          textNode.nodeValue &&
          textNode.nodeValue.includes('&') &&
          !shouldRejectTextNode(textNode)
        ) {
          batch.push(textNode);
        }
        n = walker.nextNode();
      }
      for (let i = 0; i < batch.length; i++) {
        const tn = batch[i];
        const d = decodeAll(tn.nodeValue || '');
        if (d !== tn.nodeValue) tn.nodeValue = d;
      }
    } catch (_) {
      /* TreeWalker unsupported */
    }
  }

  /** Also decode attribute values merchants sometimes double-escape (titles, placeholders) */
  const ATTR_SELECTOR = '[title*="&"][title*=";"], [placeholder*="&"][placeholder*=";"], [alt*="&"][alt*=";"]';

  function decodeEligibleAttributes(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll(ATTR_SELECTOR).forEach((el) => {
      ['title', 'placeholder', 'alt'].forEach((attr) => {
        const v = el.getAttribute(attr);
        if (v && v.includes('&')) {
          const d = decodeAll(v);
          if (d !== v) el.setAttribute(attr, d);
        }
      });
    });
  }

  function runFull(scope) {
    const root = scope && scope.nodeType ? scope : document.body;
    if (!root) return;
    decodeSubtree(root);
    decodeEligibleAttributes(root);
  }

  function onReady() {
    runFull(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  /** Shopify theme editor / AJAX sections */
  document.addEventListener('shopify:section:load', (e) => {
    const t = e && e.target;
    if (t && t.nodeType) runFull(t);
  });

  /** Throttled follow-up when apps or scripts inject markup */
  let moScheduled = false;
  const observeRoot = document.body;
  try {
    const mo = new MutationObserver(() => {
      if (moScheduled) return;
      moScheduled = true;
      requestAnimationFrame(() => {
        moScheduled = false;
        runFull(observeRoot);
      });
    });
    if (observeRoot)
      mo.observe(observeRoot, { subtree: true, childList: true, characterData: true });
  } catch (_) {
    /* no observer */
  }

  window.lwDecodeHtmlEntities = decodeAll;
  window.lwDecodeEntitiesInElement = runFull;
})();
